import React from 'react';

import { CellDescription, Link } from '@atoms';

const TableInfoColumn = ({ type, createdById, createdByName }) => {
  const id = createdById;
  const name = createdByName;

  return (
    <CellDescription label={type}>
      by <Link to={`/users/${id}`}>{name}</Link>
    </CellDescription>
  );
};

export default TableInfoColumn;
